import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getSiteList,getFilters,updateClientRenewalStatus,getClientStatusOptions } from "services/redux/contractRenewal/action";
import ContractExpiryList from "./contractExpiryList";

const mapStateToProps = (state) => ({
  siteList: state.contractRenewalReducer.siteList,
  filters: state.contractRenewalReducer.filters,
  clientStatusUpdate: state.contractRenewalReducer.clientStatusUpdate,
  clientStatusOptions:state.contractRenewalReducer.clientStatusOptions
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteList,
      getFilters,
      updateClientRenewalStatus,
      getClientStatusOptions
    },
    dispatch
  );


export default connect(mapStateToProps, mapDispatchToProps)(ContractExpiryList);
